import { OfferHeader } from '../../../../offer/modal/tabs/offer/OfferHeader';
import React from 'react';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../../../store/rootReducer';
import ChildOfferPlatformTable from './ChildOfferPlatformTable';
import ChildOfferPlatformItem from './ChldOfferPlatformItem';
import { Totals } from '../../../../offer/modal/tabs/offer/Totals';
import { TotalTypes } from '../../../../../../../../enum/TotalTypes';
import {
    downloadFile,
    formatDate,
    getSubtotalChildOfferItems,
    getSubtotalOfferItems,
} from '../../../../../../../../shared/functions/Functions';
import ItemValueSection from '../../../../../../../../shared/components/offer/ItemValueSection';
import { useTranslation } from 'react-i18next';
import { Fancybox } from '../../../../../../../../shared/components/Fancybox';
import { Fancybox as NativeFancybox } from '@fancyapps/ui';
import FilePlaceholder from '../../../../../../../../shared/components/placeholder/FilePlaceholder';
import TooltipOverlay from '../../../../../../../../shared/components/tooltip/Tooltip';
import { getTruncatedData } from '../../../../../../../../utils/helpers/getTruncatedData';
export function ChildOffer() {
    const { t } = useTranslation();
    const { campaign, initialChildOffer, isTransparentPricing, isCharity, isEditable } = useSelector(
        (state: IAllStates) => state.childOfferBrand
    );
    const feePercentage = Math.round((1 - Number(campaign?.feePercentage ?? 0.0)) * 100);
    const subTotalSum = !isEditable
        ? getSubtotalChildOfferItems(initialChildOffer?.offerItems)
        : getSubtotalOfferItems(initialChildOffer?.offerItems);
    const totalLiveFeeSum = Math.ceil(subTotalSum / (campaign?.feePercentage ?? 1)) - subTotalSum;
    const transparentGrandTotal = Math.ceil(subTotalSum / (campaign?.feePercentage ?? 1));
    const legalDocument = campaign?.contract?.legalDocuments?.[0];
    const { truncatedName: truncatedFileName, isTruncated: isFileNameTruncated } = getTruncatedData(
        legalDocument?.originalName ?? '',
        30
    );
    const { truncatedName: truncatedUploaderName, isTruncated: isUploaderNameTruncated } = getTruncatedData(
        legalDocument?.uploadedBy?.displayName ?? '',
        20
    );
    return (
        <>
            {campaign?.offers[0]?.createdAt && (
                <OfferHeader
                    createdAt={campaign?.offers[0]?.createdAt ?? ''}
                    offerItemId={campaign?.offers[0]?.id ?? 0}
                    acceptedDate={campaign?.offers[0]?.acceptedDate}
                    status={campaign?.offers[0]?.status}
                    purchaseOrderInfluencer={campaign?.offers[0]?.purchaseOrderInfluencer}
                />
            )}
            <div>
                <ChildOfferPlatformTable>
                    <>
                        {campaign?.offerPlaceholder?.totalPlatforms?.map((platform, index) => (
                            <ChildOfferPlatformItem
                                key={Number(index + platform?.id + platform?.totalFollowers)}
                                platform={platform}
                            />
                        ))}
                    </>
                </ChildOfferPlatformTable>

                {isTransparentPricing ? (
                    <div className="w-100 mt-2">
                        <Totals
                            title={TotalTypes.FEE}
                            price={totalLiveFeeSum}
                            feePercentage={feePercentage}
                            displayPlus={true}
                        />
                    </div>
                ) : (
                    <div className="my-3"></div>
                )}
                {isTransparentPricing && !isCharity && (
                    <div className="w-100 mt-2">
                        <Totals title={TotalTypes.GRAND} price={transparentGrandTotal} feePercentage={100} />
                    </div>
                )}

                {isCharity && !!campaign?.charityValueDesc && (
                    <ItemValueSection classes="px-1" description={campaign?.charityValueDesc} />
                )}
                {campaign?.contract?.personalOffer && (
                    <div className="mt-4 px-2">
                        <div>
                            <h6>{t('influencer.offer_management.modal.add_personal_offer')}</h6>
                        </div>
                        <p className="text-muted mb-0">{campaign?.contract?.personalOffer}</p>
                    </div>
                )}
                {campaign?.contract?.legalDocuments?.[0] && (
                    <div className="mt-3 px-1">
                        <div
                            className="d-flex align-items-start p-2 border rounded position-relative"
                            style={{ maxWidth: 300 }}
                        >
                            <Fancybox>
                                <FilePlaceholder
                                    file={campaign?.contract?.legalDocuments?.[0]}
                                    hideText={true}
                                    classIcon="font-22"
                                    styleContent={{ width: 40, height: 40, flexShrink: 0 }}
                                    nameFancybox="legal-document"
                                    handleDownload={() =>
                                        downloadFile(
                                            campaign?.contract?.legalDocuments?.[0]?.path ?? '',
                                            campaign?.contract?.legalDocuments?.[0]?.originalName
                                        )
                                    }
                                    right={-10}
                                />
                            </Fancybox>
                            <div className="ms-2">
                                <TooltipOverlay content={isFileNameTruncated ? legalDocument?.originalName : ''}>
                                    <p
                                        className="mb-0 fw-semibold cursor-pointer"
                                        onClick={() =>
                                            NativeFancybox.show([
                                                {
                                                    src: campaign?.contract?.legalDocuments?.[0]?.path,
                                                    type: 'iframe',
                                                },
                                            ])
                                        }
                                    >
                                        {truncatedFileName || '-'}
                                    </p>
                                </TooltipOverlay>
                                <p className="mb-0 text-muted fs-12">
                                    {t('influencer.offer_management.modal.uploaded_by')}:{' '}
                                    <TooltipOverlay
                                        content={isUploaderNameTruncated ? legalDocument?.uploadedBy?.displayName : ''}
                                        dFlex={false}
                                    >
                                        <span>{truncatedUploaderName || '-'}</span>
                                    </TooltipOverlay>
                                </p>
                                <p className="mb-0 text-muted fs-12">
                                    {t('influencer.offer_management.modal.uploaded_at')}:{' '}
                                    {formatDate(campaign?.contract?.legalDocuments?.[0]?.updatedAt)}
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
